// import tinycolor from "tinycolor2";

export const ARTISANAL_COLORS: string[] = [
  "#ef5350",
  "#EC407A",
  "#AB47BC",
  "#7E57C2",
  "#5C6BC0",
  "#42A5F5",
  "#26C6DA",
  "#26A69A",
  "#66BB6A",
  "#D4E157",
  "#FFEE58",
  "#FFA726",
  "#8D6E63",
  "#BDBDBD",
  "#78909C",
];

export const UTIL_COLORS: string[] = ["#000000", "#ffffff", "rgba(0, 0, 0, 0)"];

export const FACTORY_COLORS = new Array<Array<string>>();

for (let hue = 0; hue < 360; hue += 30) {
  const variants = new Array<string>();
  for (let lightness = 10; lightness < 100; lightness += 10) {
    variants.push(`hsl(${hue}, 100%, ${lightness}%)`);
  }
  FACTORY_COLORS.push(variants);
}
const grayVariants = new Array<string>();
for (let lightness = 10; lightness < 100; lightness += 10) {
  grayVariants.push(`hsl(0, 0%, ${lightness}%)`);
}
FACTORY_COLORS.push(grayVariants);
